import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonModal,
  IonTitle,
  IonToolbar,
  ModalOptions,
} from '@ionic/react';
import { close } from 'ionicons/icons';
import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ApplicationConfig } from '../../config/config';

type SupportFailedModalOptions = Omit<
  ModalOptions,
  'children' | 'isOpen' | 'onDidDismiss' | 'component'
> & {
  router?: HTMLIonRouterOutletElement | null;
};

export interface SupportFailedModalReturnType {
  modal: ReactElement;
  openModal: (options: SupportFailedModalOptions) => void;
}

export const useSupportFailedModal = (): SupportFailedModalReturnType => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [modalProps, setModalProps] = useState<SupportFailedModalOptions>(
    {} as SupportFailedModalOptions
  );

  const { router, ...ionModalProps } = modalProps;
  const onClose = () => {
    setIsOpen(false);
  };

  const modal = (
    <IonModal
      {...ionModalProps}
      isOpen={isOpen}
      onDidDismiss={() => setIsOpen(false)}
      presentingElement={router || undefined}
      canDismiss={true}
    >
      <IonHeader>
        <IonToolbar>
          <IonButtons slot={'start'}>
            <IonButton onClick={onClose}>
              <IonIcon icon={close} size="large" />
            </IonButton>
          </IonButtons>
          <IonTitle>{i18n.t('common:support_issue_title')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <div
          style={{ height: '100%', padding: '8px' }}
          className="ion-text-center"
        >
          <p>
            {i18n.t('common:support_error_web_desc')}
            <a
              href={`mailto:${ApplicationConfig.support.email}?subject=Beacon Support`}
            >
              {ApplicationConfig.support.email}
            </a>
          </p>
        </div>
      </IonContent>
    </IonModal>
  );

  const openModal = (options: SupportFailedModalOptions): void => {
    setModalProps(options);
    setIsOpen(true);
  };

  return {
    openModal,
    modal,
  };
};
